import { withInstall } from '../_util'

import Edittable from './Edittable'
import EdittableColumnIndex from './columns/EdittableColumnIndex'
import EdittableColumnString from './columns/EdittableColumnString'
import EdittableColumnLov from './columns/EdittableColumnLov'
import EdittableColumnCheckbox from './columns/EdittableColumnCheckbox'
import EdittableColumnNumber from './columns/EdittableColumnNumber'
import EdittableColumnDate from './columns/EdittableColumnDate'
import EdittableColumnSingleselect from './columns/EdittableColumnSingleselect'
import EdittableColumnMultiselect from './columns/EdittableColumnMultiselect'
import EdittableColumnButtongroup from './columns/EdittableColumnButtongroup'
import EdittableCellButton from './columns/EdittableCellButton'
import EdittableColumngroup from './columns/EdittableColumngroup'
import EdittableColumnDiy from './columns/EdittableColumnDiy'

export default withInstall<
  typeof Edittable,
  {
    EdittableColumnIndex: typeof EdittableColumnIndex
    EdittableColumnString: typeof EdittableColumnString
    EdittableColumnLov: typeof EdittableColumnLov
    EdittableColumnCheckbox: typeof EdittableColumnCheckbox
    EdittableColumnNumber: typeof EdittableColumnNumber
    EdittableColumnDate: typeof EdittableColumnDate
    EdittableColumnSingleselect: typeof EdittableColumnSingleselect
    EdittableColumnMultiselect: typeof EdittableColumnMultiselect
    EdittableColumnButtongroup: typeof EdittableColumnButtongroup
    EdittableCellButton: typeof EdittableCellButton
    EdittableColumngroup: typeof EdittableColumngroup
    EdittableColumnDiy: typeof EdittableColumnDiy
  }
>(Edittable, {
  EdittableColumnIndex,
  EdittableColumnString,
  EdittableColumnLov,
  EdittableColumnCheckbox,
  EdittableColumnNumber,
  EdittableColumnDate,
  EdittableColumnSingleselect,
  EdittableColumnMultiselect,
  EdittableColumnButtongroup,
  EdittableCellButton,
  EdittableColumngroup,
  EdittableColumnDiy,
})

export * from './Edittable'
export { default as useEdittable } from './hooks/useEdittable'
